import React from 'react'

export default function BannerSlide(props) {
    return (
        <div className="w-full px-4 rounded-xl lg:min-h-bannerDesktop lg:h-bannerDesktop pb-2">
            <img src={props.image} alt="" className="object-cover h-full w-full rounded-xl" />
        </div>
    )
}
